import axios from 'axios';
import { verifyEnvUrl } from 'util/verifyEnvUrl';

const prdURL = 'https://us-central1-acordo-fechado-dev.cloudfunctions.net/blocklistV2';
const devURL = 'https://us-central1-acordo-fechado-dev.cloudfunctions.net/blocklistV2Dev';

// const devURL = 'http://localhost:8081';
const blockListApiV2 = axios.create( {
	baseURL: verifyEnvUrl( prdURL,devURL )
} );

blockListApiV2.interceptors.request.use( async config => {
	const token = localStorage.getItem( 'af-token' );
	if ( token ) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
} );

export default blockListApiV2;
